import React, { useState, useEffect } from 'react';
import CampoDataHora from './CampoDataHora';

// 💬 Agendar mensagem de WhatsApp PARA o cliente, na data/hora escolhida.
// Reusa a fila da Comunicação (POST /comunicacao/fila): o robô envia do
// número da empresa e retenta por até 24h se a sessão estiver caída.
// Uso: <AgendarMensagemCliente alvo={{cliente_id, cliente_nome, telefone}} onFechar={...} />

const inp = { width: '100%', padding: '5px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff' };
const token = () => localStorage.getItem('token');
const agoraLocal = () => new Date(Date.now() - 3 * 3600000).toISOString().slice(0, 16);

export default function AgendarMensagemCliente({ alvo, onFechar }) {
  const [texto, setTexto] = useState('');
  const [quando, setQuando] = useState('');
  const [telefone, setTelefone] = useState(alvo.telefone || '');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [feito, setFeito] = useState(false);

  // Templates predefinidos (os mesmos da página 💬 Comunicação)
  const [templates, setTemplates] = useState([]);
  const [templateSel, setTemplateSel] = useState('');
  const [dadosCliente, setDadosCliente] = useState(null); // pra preencher {marca}/{processo}

  // De qual WhatsApp a mensagem sai: '' = número da empresa; ou a sessão
  // pessoal de um closer (conectada em Configurações)
  const [remetentes, setRemetentes] = useState([]);
  const [enviarPor, setEnviarPor] = useState('');

  const [buscandoTel, setBuscandoTel] = useState(false);

  useEffect(() => {
    fetch('/comunicacao/templates', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.ok ? r.json() : []).then(setTemplates).catch(() => {});
    fetch('/usuarios', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.ok ? r.json() : []).then(us => setRemetentes(
        us.filter(u => ((u.cargo || '').toLowerCase().includes('closer') || (u.cargo || '').toLowerCase().includes('administrador'))
          && u.email !== 'clau@preservamarcas.com.br')
      )).catch(() => {});
    // O modal abre vazio e o telefone chega por aqui (cliente ou oportunidade):
    // quem chama não precisa esperar rede nenhuma pra abrir a janela.
    if (alvo.cliente_id) {
      setBuscandoTel(!alvo.telefone);
      fetch(`/clientes/${alvo.cliente_id}`, { headers: { Authorization: `Bearer ${token()}` } })
        .then(r => r.ok ? r.json() : null)
        .then(c => { setDadosCliente(c); if (c?.telefone) setTelefone(prev => prev || c.telefone); })
        .catch(() => {}).finally(() => setBuscandoTel(false));
    } else if (alvo.oportunidade_id && !alvo.telefone) {
      setBuscandoTel(true);
      fetch(`/oportunidades/${alvo.oportunidade_id}`, { headers: { Authorization: `Bearer ${token()}` } })
        .then(r => r.ok ? r.json() : null)
        .then(o => { if (o?.telefone) setTelefone(prev => prev || o.telefone); })
        .catch(() => {}).finally(() => setBuscandoTel(false));
    }
  }, [alvo.cliente_id, alvo.oportunidade_id, alvo.telefone]);

  function aplicarTemplate(id) {
    setTemplateSel(id);
    const t = templates.find(x => x._id === id);
    if (!t) return;
    const procs = Array.isArray(dadosCliente?.processos) ? dadosCliente.processos : [];
    setTexto(t.texto
      .replace(/\{nome\}/gi, alvo.cliente_nome || dadosCliente?.nome || '')
      .replace(/\{marca\}/gi, procs[0]?.nome_marca || '')
      .replace(/\{processo\}/gi, procs[0]?.numero_processo || '')
      .replace(/\{telefone\}/gi, telefone || '')
      .replace(/\{data\}/gi, new Date().toLocaleDateString('pt-BR')));
    setErro('');
  }

  const [anexos, setAnexos] = useState([]);
  const [subindo, setSubindo] = useState(false);

  // 📎 Mesmo mecanismo da página Comunicação: sobe pro /comunicacao/anexo e
  // a fila envia junto com a mensagem na hora agendada
  async function anexar(files) {
    if (!files?.length) return;
    setSubindo(true);
    const fd = new FormData();
    for (const f of files) fd.append('arquivo', f);
    try {
      const r = await fetch('/comunicacao/anexo', {
        method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd,
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'Falha no upload');
      setAnexos(a => [...a, ...(d.anexos || [])]);
      setErro('');
    } catch (e) { setErro('Anexo falhou: ' + e.message); }
    setSubindo(false);
  }
  function removerAnexo(arq) {
    setAnexos(a => a.filter(x => x.arquivo !== arq));
    fetch(`/comunicacao/anexo/${encodeURIComponent(arq)}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } }).catch(() => {});
  }

  async function agendar() {
    const tel = telefone.replace(/\D/g, '');
    if (tel.length < 10) return setErro('Informe o telefone com DDD.');
    if (!texto.trim()) return setErro('Escreva a mensagem.');
    if (!quando) return setErro('Escolha a data e a hora do envio.');
    if (quando <= agoraLocal()) return setErro('Escolha um horário no futuro.');
    setSalvando(true);
    const r = await fetch('/comunicacao/fila', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({
        cliente_id: alvo.cliente_id || '',
        cliente_nome: alvo.cliente_nome || '',
        telefone: tel,
        template_id: templateSel || '',
        template_titulo: templates.find(t => t._id === templateSel)?.titulo || '',
        enviar_por: enviarPor || '',
        enviar_por_nome: enviarPor ? (remetentes.find(u => u._id === enviarPor)?.nome || '') : '',
        texto_final: texto.trim(),
        anexos,
        agendado_para: new Date(quando).toISOString(),
      }),
    }).then(x => x.json()).catch(() => ({ erro: 'Falha ao agendar.' }));
    setSalvando(false);
    if (r.erro) return setErro(r.erro);
    setFeito(true);
  }

  const atalho = (rot, calc) => (
    <button key={rot} type="button" onClick={() => { setQuando(calc()); setErro(''); }}
      style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '3px 9px', fontSize: 11, cursor: 'pointer', color: '#374151' }}>{rot}</button>
  );

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 460, maxWidth: '94vw', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', color: '#fff', fontWeight: 700, fontSize: 14 }}>
          💬 Agendar mensagem pro cliente
        </div>
        <div style={{ padding: 14 }}>
          {feito ? (
            <>
              <div style={{ fontSize: 14, color: '#15803d', fontWeight: 700 }}>✅ Mensagem agendada!</div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
                Ela sai do WhatsApp da empresa no horário marcado. Dá pra acompanhar (ou cancelar) na tela 💬 Comunicação.
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
                <button type="button" onClick={onFechar} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Fechar</button>
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{alvo.cliente_nome || 'Cliente'}</div>
              <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>
                WhatsApp do cliente {buscandoTel && <span style={{ color: '#b45309' }}>· buscando…</span>}
              </div>
              <input value={telefone} onChange={e => { setTelefone(e.target.value); setErro(''); }}
                placeholder={buscandoTel ? 'buscando telefone do cadastro…' : '(83) 99999-9999'} style={inp} />
              <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>Enviar pelo WhatsApp de</div>
              <select value={enviarPor} onChange={e => setEnviarPor(e.target.value)} style={inp}>
                <option value="">📢 Número da empresa</option>
                {remetentes.map(u => <option key={u._id} value={u._id}>👤 {u.nome}</option>)}
              </select>
              {enviarPor && (
                <div style={{ fontSize: 11, color: '#b45309', marginTop: 4 }}>
                  ⚠ O WhatsApp de {remetentes.find(u => u._id === enviarPor)?.nome || 'quem envia'} precisa estar conectado
                  (⚙️ Configurações → Conectar). Se estiver fora do ar na hora, o sistema retenta por até 24h.
                </div>
              )}
              {templates.length > 0 && (
                <>
                  <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>
                    Template <span style={{ color: '#9ca3af', fontWeight: 400 }}>(opcional — os mesmos da página Comunicação)</span>
                  </div>
                  <select value={templateSel} onChange={e => aplicarTemplate(e.target.value)} style={inp}>
                    <option value="">— escrever do zero —</option>
                    {templates.map(t => <option key={t._id} value={t._id}>{t.titulo}</option>)}
                  </select>
                </>
              )}
              <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>Mensagem</div>
              <textarea value={texto} onChange={e => { setTexto(e.target.value); setErro(''); }} rows={4}
                placeholder="Ex.: Olá! Lembrando da nossa reunião amanhã às 14h. Qualquer coisa é só chamar. — Preserva Marcas"
                style={{ ...inp, resize: 'vertical' }} />
              <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>Anexos <span style={{ color: '#9ca3af' }}>(opcional — PDF, imagem, etc.)</span></div>
              <label style={{ display: 'inline-block', background: '#f3f4f6', border: '1px dashed #9ca3af', borderRadius: 4, padding: '5px 12px', fontSize: 12, color: '#374151', cursor: 'pointer' }}>
                {subindo ? '⏳ Enviando…' : '📎 Anexar arquivo'}
                <input type="file" multiple style={{ display: 'none' }} disabled={subindo}
                  onChange={e => { anexar(Array.from(e.target.files || [])); e.target.value = ''; }} />
              </label>
              {anexos.length > 0 && (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                  {anexos.map(a => (
                    <span key={a.arquivo} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1d4ed8', borderRadius: 12, padding: '2px 10px', fontSize: 11.5, fontWeight: 600, maxWidth: 220 }}>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>📄 {a.nome || a.arquivo}</span>
                      <span onClick={() => removerAnexo(a.arquivo)} style={{ cursor: 'pointer', fontWeight: 800 }}>×</span>
                    </span>
                  ))}
                </div>
              )}

              <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>Enviar em</div>
              <CampoDataHora value={quando} onChange={v => { setQuando(v); setErro(''); }} style={inp} />
              <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                {atalho('Em 1 hora', () => { const d = new Date(Date.now() - 3 * 3600000); d.setUTCHours(d.getUTCHours() + 1); return d.toISOString().slice(0, 16); })}
                {atalho('Hoje 17h', () => new Date(Date.now() - 3 * 3600000).toISOString().slice(0, 10) + 'T17:00')}
                {atalho('Amanhã 9h', () => { const d = new Date(Date.now() - 3 * 3600000); d.setUTCDate(d.getUTCDate() + 1); return d.toISOString().slice(0, 10) + 'T09:00'; })}
              </div>
              <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 9 }}>
                A mensagem sai do número da empresa. Se o WhatsApp estiver fora do ar na hora, o sistema retenta por até 24h.
              </div>
              {erro && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 8 }}>⚠ {erro}</div>}
              <div style={{ display: 'flex', gap: 8, marginTop: 14, justifyContent: 'flex-end' }}>
                <button type="button" onClick={onFechar} style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '6px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
                <button type="button" onClick={agendar} disabled={salvando} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>
                  {salvando ? 'Agendando…' : '💬 Agendar envio'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
